





















import { Vue, Component, Prop } from "vue-property-decorator";
import { Isocron } from "../../models";

@Component({})
export default class MeansTypeSelect extends Vue {
  @Prop() readonly value!: string | null;
  @Prop({ default: false }) readonly disabled!: boolean;

  onSelected(key: string) {
    if (this.disabled) {
      return;
    }
    this.$emit("input", key);
  }

  get items() {
    return Isocron.meansTypes;
  }
}
